import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DateRange } from '../../models/dateRange.model';

@Component({
  standalone: false,
    selector: 'app-time-range-dialog',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: 'timeRangeDialog.component.html',
})
export class TimeRangeDialogComponent {

    constructor(public dialogRef: MatDialogRef<TimeRangeDialogComponent>, public data: DateRange) { }

    isDisabled() {
        return !this.data || !this.data.startDate || !this.data.endDate;
    }

    ok() {
        this.dialogRef.close(this.data);
    }
}
